import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const CMIEducationPolicy = () => {
     useEffect(() => {
        document.title = 'CMI Education Policy -  Mary Matha Cmi  Academy';   
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
        <li><Link to="/"> Home</Link> </li>  
        <li>Academic</li>
        <li>CMI Education Policy </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>CMI Education Policy  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
             <p>Being with the charism of  <b>St.Kuriakose Elias Chavara, the founder of Carmalites of Mary Immaculate (CMI),</b>  we seek to engage with the people of all cultures, value system and faith traditions by instilling the love of knowledge, the spirit of reflection and contemplation and respect for one’s fellowman that characterizes catholic and Carmelites teachings.</p>
             <p>To impart knowledge among all people especially, the poor and the marginalized is the deeply embedded key component in our mission. Working collaboratively with each other, we provide cohesive programming with the team work of an outstanding professionals, who are intellectually competent, morally sound, right, just and human in their dealings.</p>
             <p>The historic order to start schools adjacent to the churches triggered the emergence of galaxy of educational institutions all over the state. Thus it has become the basis of socio-economic development of the whole nation.</p>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default CMIEducationPolicy
